import {
  Mutation,
  TabaPayChallengeAuthenticateInput,
  TabaPayChallengeAuthenticateResult,
  TabaPayChallengeAuthenticateResultTypenames,
} from '@varo/graphql-schema-types';
import { checkError } from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import { useState } from 'react';
import TabaPayChallengeAuthenticate from 'services/graphql/mutations/MoveMoney/TabaPay/ChallengeAuthenticate';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useMutation } from 'urql';

export const useTabaPayChallengeAuthenticate = () => {
  const [{ data, fetching, error }, executeMutation] = useMutation<Mutation>(
    TabaPayChallengeAuthenticate,
  );
  const { defaultTitle, defaultMessage } = useDefaultErrorStrings();
  const [errorScreen, setErrorScreen] = useState<{
    screenType: ErrorScreenType.Error;
    messageHeadline: string;
    messageBody: string;
  } | null>(null);

  const triggerAuthenticate = async (
    input: TabaPayChallengeAuthenticateInput,
  ): Promise<TabaPayChallengeAuthenticateResult> => {
    const result = await executeMutation({ input });

    if (!result.data) {
      throw new Error('No data returned from challenge init');
    }

    if (
      result.data.tabaPayChallengeAuthenticate?.__typename ===
      TabaPayChallengeAuthenticateResultTypenames.TabaPayChallengeAuthenticateResultError
    ) {
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        messageHeadline: result.data.tabaPayChallengeAuthenticate.title,
        messageBody: result.data.tabaPayChallengeAuthenticate.message,
      });
    }

    if (error) {
      const errorObject = checkError(error, defaultTitle, defaultMessage);
      setErrorScreen({
        screenType: ErrorScreenType.Error,
        ...errorObject,
      });
    }
    return result.data.tabaPayChallengeAuthenticate;
  };

  return {
    triggerAuthenticate,
    triggerAuthenticateResult: {
      errorScreen,
      data: data?.tabaPayChallengeAuthenticate,
      fetching,
      error,
    },
  };
};
